module.exports = __webpack_public_path__ + "img/avatar-s-23.68d0b775.jpg";